export const GROOVE_WRAPPER_ID_BASE = 'groove-container'
export const IFRAME_ID = 'groove-iframe-element'
export const IFRAME_TITLE = 'Website support platform help button'
export const PUBLIC_API = [
  'close',
  'debug',
  'identifyCompany',
  'identifyContact',
  'init',
  'logout',
  'open',
  'setAttribute',
  'toggle',
  'setCompany',
  'setContact',
  'setMainScrollElement',
  'trackEvent',
  'trackPageView',
  'trackPageUnload',
  'updateSettings',
  'updateTranslations',
  'pushRoute',
  'replaceRoute',
  'getRoute',
  'destroy',
]
